import { baseContainer } from "@base-provider";
import { SFUserDetailsActions } from "@sf-core";
import { API_PARAM } from "../constants/apiParams";
import { base } from "@base-provider";

export const SYSTEM_MODIFIED_NAME = "SYSTEM";

export default class UserService {
  constructor() {
    this.SYSTEM_MODIFIED_NAME = "SYSTEM";
  }

  async getUserDetails(userName) {
    let user = this.getCachedUserDetails(userName);
    if (user && !user.loading) {
      return user;
    } else if (user && user.loading) {
      await this.#waitForUser(user);
      user = this.getCachedUserDetails(userName);
    } else {
      baseContainer.store.dispatch(
        SFUserDetailsActions.initializeUser({ userName })
      );
      let response = await base.post({
        url: API_PARAM.USER_DETAILS,
        data: { userName },
      });

      baseContainer.store.dispatch(SFUserDetailsActions.cacheUser(response.data));
      user = this.getCachedUserDetails(userName);
    }
    return user;
  }

  async #waitForUser(user, counter) {
    var _this = this;

    if (!counter) counter = 1;

    return new Promise((resolve) =>
      setTimeout(async () => {
        if (user.loading && counter < 20) {
          await _this.#waitForUser(user, counter + 1);
        }

        resolve();
      }, 100)
    );
  }

  getCachedUserDetails(userName) {
    return baseContainer
      .getStoreState()
      .userDetails.users.find((x) => x.userName === userName);
  }
}
